import CalendarEvent from '@/models/CalendarEvent'

export default function (value) {
  const calendarOption = CalendarEvent.calendarOptions.find(
    calendarOption => calendarOption.value === value
  )

  return calendarOption != null ? calendarOption.name : value
}
